import request from './request';

export const API_BASE = request.defaults.baseURL || '';

export function heartbeat() {
  return request.post('/agent/heartbeat', {});
}

export function listConversations() {
  return request.get('/agent/conversation/list');
}

export function conversationMessages(id, sinceId = 0) {
  return request.get(`/agent/conversation/${id}/messages`, { params: { since_id: sinceId } });
}

export function replyConversation(id, payload) {
  return request.post(`/agent/conversation/${id}/reply`, payload);
}

export function sendBusyNotice(id, content) {
  return request.post(`/agent/conversation/${id}/busy-notice`, { content });
}

export function agentUpload(file) {
  const fd = new FormData();
  fd.append('file', file);
  return request.post('/agent/upload', fd);
}

export function closeConversation(id) {
  return request.post(`/agent/conversation/${id}/close`, {});
}

export function transferConversation(id, toAgentId) {
  return request.post(`/agent/conversation/${id}/transfer`, { to_agent_id: toAgentId });
}

export function quickReplies() {
  return request.get('/agent/quick-reply/list');
}

export function colleagues() {
  return request.get('/agent/colleague/list');
}

export function searchFaq(q) {
  return request.get('/agent/faq/search', { params: { q } });
}

export function pushConversationFaq(conversationId, payload) {
  return request.post(`/agent/conversation/${conversationId}/faq-push`, payload);
}

